import { AlpineComponent } from 'alpinejs';
import axios from 'axios';
import ListItem from "@dw_template/components/AjaxList/Classes/Item.ts";
import {decode} from "html-entities";
import {ListXDataContext} from "@dw_template/components/AjaxList/Classes/List.ts";

type SearchData = {
  searchQuery: string;
  submitSearchForm: (event: Event) => void;
  submitSearchFormWithQuery: () => void;
  isLoading: boolean;
  hasSearched: boolean;

  items: Array<ListItem>;
  getVisibleItems: () => Array<ListItem>;
  fetchItemsContent: (url: string) => void;
  addHighlightToLinks: () => void;
}

export type ListComponent<Item extends ListItem> = AlpineComponent<ListXDataContext<Item>>;
export interface ListOptions {
  getItemsUrl: string,
  getItemsContentUrl: string,
  pageSize: number,
}

export default (options: any):AlpineComponent<SearchData> => ({
  searchQuery: '',
  items: [],
  isLoading: false,
  hasSearched: false,

  init() {
    const searchParam = new URLSearchParams(window.location.search).get('search');
    if (searchParam) {
      this.searchQuery = searchParam;
      this.submitSearchFormWithQuery();
      this.addHighlightToLinks();
    } else {
      this.searchQuery = '';
    }
  },

  submitSearchForm(event: Event) {
    event.preventDefault();

    if (!this.searchQuery || this.searchQuery.length < 3) {
      return;
    }

    // set searched query in url as ?search=...
    const url = new URL(window.location.href);
    url.searchParams.set('search', this.searchQuery);
    window.history.pushState({}, '', url.toString());

    let items:Array<ListItem> = [];
    this.hasSearched = true;
    this.isLoading = true;

    return axios({
      url: options.getItemsUrl,
      params: {
        query: this.searchQuery,
        lang: options.lang,
      },
      method: 'post',
    })
    .then((response) => {
      if (response.data.length) {
        items = response.data;
      }
      this.addHighlightToLinks();
    })
    .catch((error) => {
      console.error('Oops an error occurred: ', error);
    })
    .finally(() => {
      // @ts-ignore
      this.items = items;
      this.fetchItemsContent('');
      this.isLoading = false;
    });
  },

  submitSearchFormWithQuery() {
    if (!this.searchQuery || this.searchQuery.length < 3) {
      return;
    }

    let items:Array<ListItem> = [];
    this.hasSearched = true;
    this.isLoading = true;
    const getItemsUrl = "/wp-json/devsk/get-search-results";
    const getItemsContentUrl = "/wp-json/devsk/get-search-results-content";

    return axios({
      url: getItemsUrl,
      params: {
        query: this.searchQuery,
        lang: options.lang,
      },
      method: 'post',
    })
      .then((response) => {
        if (response.data.length) {
          items = response.data;
        }
        this.addHighlightToLinks();
      })
      .catch((error) => {
        console.error('Oops an error occurred: ', error);
      })
      .finally(() => {
        // @ts-ignore
        this.items = items;
        this.fetchItemsContent(getItemsContentUrl);
        this.isLoading = false;
      });
  },

  fetchItemsContent(url: string) {
    if (!options.getItemsContentUrl) {
      return;
    }

    let getItemsContentUrl = "";
    if (url) {
      getItemsContentUrl = url;
    } else {
      getItemsContentUrl = options.getItemsContentUrl;
    }

    const visibleItems = this.getVisibleItems();
    const uids = visibleItems.filter((item: ListItem) => !item.content).map((item: ListItem) => item.uid).join(',');

    if (uids) {
      axios.get(getItemsContentUrl, {
        params: {
          uids: uids,
        }
      })
        .then((response) => {
          response.data.forEach((responseItem: ListItem) => {
            const index = this.items.findIndex((item: ListItem) => responseItem.uid === item.uid);
            this.items[index].content = decode(responseItem.content)
          });
        })
        .catch((error) => {
          console.error('Oops an error occurred: ', error);
        });
    }
  },

  getVisibleItems() {
    return this.items;
  },

  addHighlightToLinks() {
    if (!this.searchQuery || this.searchQuery.length < 3) {
      return;
    }

    setTimeout(() => {
      const searchResultLinks = document.querySelectorAll<HTMLAnchorElement>('.search-result');
      
      searchResultLinks.forEach((link) => {
        if (link.href && !link.href.includes('highlight=')) {
          const url = new URL(link.href);
          url.searchParams.set('highlight', this.searchQuery);
          link.href = url.toString();
        }
      });
    }, 100);
  }
});
